// virtual module to share with setup js

import * as dom from "./js/_dom.js";
import * as component from "./js/component.js";
import * as debounce from "./js/debounce.js";
import * as menu from "./js/_menu.js";
import * as res from "./js/res.js";
import * as datepicker from "./js/datepicker.js";
import * as modal from "./js/_modal.js";
import * as colorutils from "./js/colorutils.js";
import * as colorpicker from "./js/colorPicker.js";
import * as context from "./js/context.js";
import * as cookie from "./js/cookie.js";
import { ensureVisible } from "./js/_ensureVisible.js";
import { ready } from "./js/ready.js";

export { dom, component, debounce, menu, res, datepicker, modal, colorutils, colorpicker, context, cookie, ensureVisible, ready };